import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export const AdminRoute = ({ element }) => {
    const { user } = useAuth();
    return user?.role === "admin" ? element : <Navigate to="/" />;
  };
  

